"use client";
import React from "react";

interface HeaderProps {
  onClose?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onClose }) => {
  return (
      <header className="flex flex-col items-center mb-5">
        <div className="flex gap-0.5 mb-5 max-sm:flex-col max-sm:w-full" />
        <a href="/">
          <img
            src="/img/logo.svg"
            alt="Muse Studios Logo"
            className="w-[120px]"
          />
        </a>

        <button
          className="absolute top-5 right-0 z-10 items-center px-3 py-2 text-xs cursor-pointer border-[none] text-[black]"
          onClick={onClose}
        >
          <span className="w-[25px] h-[3px] bg-black rounded-md ease-in-out block rotate-45 "></span>
          <span className="w-[25px] h-[3px] bg-black rounded-md ease-in-out block -rotate-45 translate-y-[-3px]"></span>
        </button>
      </header>
  );
};
